import { getGACustomDimensions } from '@tracking/getGACustomDimensions'
import { googleTagManagerDataLayer, isGoogleTagManagerDefined } from '@tracking/googleTagManagerDataLayer'

export type TrackingEvent = {
    eventName: string
    eventParams: Record<string, unknown>
}

/**
 * Tracking events
 *
 * @see {@link https://developers.google.com/analytics/devguides/collection/gtagjs/events}
 */
export function trackEvent({ eventName, eventParams }: TrackingEvent): void {
    if (!isGoogleTagManagerDefined()) {
        return
    }

    googleTagManagerDataLayer.push({
        event: eventName,
        ...getGACustomDimensions(),
        ...eventParams,
        isGAEvent: 1,
    })
}
